import { Outlet } from 'react-router-dom';

import { Box, Divider, useMantineTheme } from '@mantine/core';

import { CopyrightNotice, RouteHead } from '@/components/atoms';
import { MarketingHeader } from '@/components/organisms';

export function MarketingLayout() {
  const theme = useMantineTheme();
  return (
    <Box style={{ minHeight: '100vh', backgroundColor: 'var(--assay-bg)' }}>
      <RouteHead />
      <MarketingHeader />
      <Box component="main">
        <Outlet />
      </Box>
      <Divider style={{ borderColor: theme.other.oreBorder }} />
      <CopyrightNotice />
    </Box>
  );
}
